import {ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {MixAndMatchScheduleEntityModel} from "../mix-and-match-schedule-entity.model";
import {MixAndMatchScheduleData} from "../mix-and-match-schedule.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-mix-and-match-schedule-edit-page",
    templateUrl: "./mix-and-match-schedule-edit-page.component.html",
    providers: [provideEntityModel(MixAndMatchScheduleEntityModel)]
})
export class MixAndMatchScheduleEditPageComponent extends AbstractEditPage implements OnInit {

    mixAndMatchLocked: boolean = false;

    constructor(public model: MixAndMatchScheduleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService, false);
    }

    get data(): MixAndMatchScheduleData {
        return <MixAndMatchScheduleData>this.model.data;
    }

    ngOnInit(): void {
        if (this.editPageComponent.stackedPageContextService && this.editPageComponent.stackedPageContextService.params.parentEntity) {
            this.data.mixAndMatch = this.editPageComponent.stackedPageContextService.params.parentEntity;
            this.mixAndMatchLocked = true;
        }
    }
}
